module.exports = __webpack_public_path__ + "static/media/teamEnvision_logo.a48f0113.png";